/* eslint-disable import/prefer-default-export */
export const MSG_AUTH_EXPIRE = 'Your authorization has expired. Please refresh the page and start again. Thanks!';
